







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CourseSearchCardsMobile from 'frontend/components/search/CourseSearchCardsMobile.vue';
import { CourseData } from 'frontend/components/search/types';

@Component({
  components: {
    CourseSearchCardsMobile,
  },
})
export default class AllCourseSearchCards extends Vue {
  @Prop(Array) readonly courses!: CourseData[];
  @Prop(String) readonly queryID!: string;
}
